import { Container, Row, Col, Button } from "react-bootstrap";
import { Newsarticles } from "../home/newsarticles/newsarticles";
import "./aboutus.css";
import aboutusBg from "../../assets/images/aboutus-bg.png";
import aboutusDoctorImg from "../../assets/images/aboutus-docter-img.jpg";
import aboutusVideoBg from "../../assets/images/aboutus-videobg.jpg";
import aboutusDoctor1 from "../../assets/images/aboutus-docter1.png";
import aboutusDoctor2 from "../../assets/images/aboutus-docter2.png";
import aboutusDoctor3 from "../../assets/images/aboutus-docter3.png";
import youtubeIcon from "../../assets/icons/youtube-icon.svg";

export const AboutUs = () => {
  const teamMembers = [
    {
      name: "Dr. John Smith",
      specialty: "Cardiologist",
      image: aboutusDoctor1,
    },
    {
      name: "Dr. Sarah Johnson",
      specialty: "Neurologist",
      image: aboutusDoctor2,
    },
    {
      name: "Dr. Michael Brown",
      specialty: "Pediatrician",
      image: aboutusDoctor3,
    },
    {
      name: "Dr. Emily Davis",
      specialty: "Dermatologist",
      image: aboutusDoctor1,
    },
    {
      name: "Dr. James Wilson",
      specialty: "Orthopedic",
      image: aboutusDoctor2,
    },
    {
      name: "Dr. Lisa Anderson",
      specialty: "Gynecologist",
      image: aboutusDoctor3,
    },
  ];

  return (
    <div className="about-us">
      {/* Hero Section */}
      <section
        className="about-hero"
        style={{ backgroundImage: `url(${aboutusBg})` }}
      >
        <div className="about-hero__overlay">
          <Container>
            <p className="about-hero__label">About US</p>
            <h1 className="about-hero__title">
              Connecting Doctor to trusted care worldwide and seamless support.
            </h1>
          </Container>
        </div>
      </section>

      {/* Who We Are Section */}
      <section className="who-we-are">
        <div className="who-we-are__inner">
          <div className="who-we-are__img-wrap">
            <img
              src={aboutusDoctorImg}
              alt="Medical Team"
              className="who-we-are__img"
            />
          </div>
          <div className="who-we-are__card">
            <h2 className="who-we-are__title">Who We are?</h2>
            <p className="who-we-are__text">
              At Bizaario Care, we believe that quality healthcare should be
              accessible to everyone, everywhere. We specialize in medical
              tourism, connecting patients from around the world to trusted
              hospitals, accredited doctors, and advanced treatments at
              affordable costs.
            </p>
          </div>
        </div>
      </section>

      {/* Our Mission Section */}
      <section className="our-mission">
        <Container>
          <div className="our-mission-div">
            <h2 className="our-mission__title">Our Mission</h2>
            <p className="our-mission__text">
              Our mission is to deliver accurate, reliable, and timely testing
              services that ensure the safety, quality, and compliance of
              products across industries. We strive to provide exceptional value
              to our customers through innovative solutions, expert knowledge,
              and a commitment to excellence. Our goal is to be a trusted
              partner in quality assurance, helping businesses meet industry
              standards and protect consumer well-being. To make world-class
              healthcare accessible, reliable, and affordable by bridging the
              gap between patients and providers across the globe.
            </p>
          </div>
        </Container>
      </section>

      {/* Video Section */}
      <section className="video-section">
        <div
          className="video-section__wrapper"
          style={{ backgroundImage: `url(${aboutusVideoBg})` }}
        >
          <button className="video-section__play-btn" aria-label="Play video">
            <img
              src={youtubeIcon}
              alt="Play"
              className="video-section__play-icon"
            />
          </button>
        </div>
      </section>

      {/* Meet Our Team Section */}
      <section className="meet-team">
        <Container>
          <div className="meet-team__header">
            <h2 className="meet-team__title">Meet Our Team</h2>
            <p className="meet-team__subtitle">
              Meet Our Leadership Team. Our leadership team brings together
              expertise and vision, driving innovation and ensuring the highest
              standards of Service.
            </p>
          </div>
          <Row className="g-3">
            {teamMembers.map((member, index) => (
              <Col key={index} xs={12} sm={6} md={4}>
                <div className="team-card">
                  <div className="team-card__media">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="team-card__img"
                    />
                    <div className="team-card__actions">
                      <Button className="team-card__btn-primary w-100">
                        {member.name}
                      </Button>
                      <Button
                        variant="outline-secondary"
                        className="team-card__btn-outline w-100"
                      >
                        View Profile
                      </Button>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* News And Articles Section */}
      <section className="about-news">
        <Newsarticles gridMode />
      </section>
    </div>
  );
};
